import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../useWeb3";
import { InstitusionContract } from "../../utils/contractHelpers";
import Environment from "../../utils/Environment";

const usePurchaseEth1 = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();

  const tokenAddress = Environment.instituson;
  const contract = InstitusionContract(tokenAddress, web3);

  const purchaseEth1 = useCallback(
    async (min, amount, postApiRes, id, balance) => {
      if (!account) throw new Error("WALLET_NOT_CONNECTED");

      /* ------------------ Amount calculation ------------------ */
      const fixedAmount = Math.round(parseFloat(amount).toFixed(6) * 1e12) / 1e12;
      const nd = web3.utils.toWei(fixedAmount.toString(), "ether");

      /* ------------------ Min value ------------------ */
      let minvalue = min * 0.99;
      minvalue = Math.round(parseFloat(minvalue).toFixed(6) * 1e12) / 1e12;
      minvalue = web3.utils.toWei(minvalue.toString(), "ether");

      console.log(
        postApiRes.code,
        id,
        postApiRes.price,
        postApiRes.deadline,
        minvalue,
        "usePurchaseEth1 params"
      );

      try {
        return new Promise(async (resolve, reject) => {
          let gas;
          let gasPrice;

          try {
            gasPrice = await web3.eth.getGasPrice();
            gasPrice = parseInt(gasPrice) + 3000000000;

            gas = await contract.methods
              .purchaseWithETH(
                postApiRes.code,
                id,
                postApiRes.price,
                postApiRes.deadline,
                minvalue,
                postApiRes?.v,
                postApiRes?.r,
                postApiRes?.s
              )
              .estimateGas({ value: nd, from: account, gasPrice });
          } catch (err) {
            return reject(err);
          }

          contract.methods
            .purchaseWithETH(
              postApiRes.code,
              id,
              postApiRes.price,
              postApiRes.deadline,
              minvalue,
              postApiRes?.v,
              postApiRes?.r,
              postApiRes?.s
            )
            .send({ value: nd, from: account, gas, gasPrice })

            /* (optional) log tx hash */
            .on("transactionHash", (hash) => {
              console.log("PurchaseEth1 tx hash:", hash);
            })

            /* ✅ RESOLVE ONLY ON RECEIPT */
            .on("receipt", (receipt) => {
              console.log("PurchaseEth1 confirmed:", receipt);
              resolve({ transactionHash: receipt?.transactionHash });
            })

            /* ❌ ERROR */
            .on("error", (error) => {
              console.error("PurchaseEth1 error:", error);
              reject(error);
            });
        });
      } catch (error) {
        throw error;
      }
    },
    [account, contract, web3]
  );

  return { purchaseEth1 };
};

export default usePurchaseEth1;

// import { useCallback, useState } from "react";
// import useWeb3 from "../useWeb3";
// import { InstitusionContract } from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";
// import Environment from "../../utils/Environment";
// import { toast } from "react-toastify";

// const PurchaseEth1 = () => {
//   // const [balance, setBalance] = useState(null);
//   const { account } = useWeb3React();
//   const web3 = useWeb3();
//   const tokenAddress = Environment.instituson;
//   const contract = InstitusionContract(tokenAddress, web3);
//   const purchaseEth1 = useCallback(
//     async (min,amount, postApiRes,id,balance) => {
//     let amount11 = parseFloat(amount).toFixed(6)
//       let amount1 = Math.round((amount11) * 1e12) / 1e12;
//       let nd = web3.utils.toWei(amount1.toString(), "ether");

//       let minvalue=min*0.99
//       minvalue= parseFloat(minvalue).toFixed(6)
//       minvalue=Math.round((minvalue) * 1e12) / 1e12;
//       minvalue= web3.utils.toWei(minvalue.toString(), "ether");
//       // console.log(postApiRes.code,id,postApiRes.price,postApiRes.deadline,minvalue, postApiRes?.v, postApiRes?.r, postApiRes?.s,'noooor',contract);
//       let gas
//       try {
//         let gasPrice = await web3.eth.getGasPrice()
//         gasPrice = parseInt(gasPrice) + 3000000000
//          gas = await contract.methods
//           .purchaseWithETH(postApiRes.code,id,postApiRes.price,postApiRes.deadline,minvalue, postApiRes?.v, postApiRes?.r, postApiRes?.s)
//           .estimateGas({
//             value: nd,
//             from: account,
//             gasPrice
//           });
//         const details = await contract.methods
//           .purchaseWithETH(postApiRes.code,id,postApiRes.price,postApiRes.deadline,minvalue,postApiRes?.v, postApiRes?.r, postApiRes?.s)
//           .send({
//             value: nd,
//             from: account,
//             gas: gas,
//             gasPrice
//           });
//         return details;
//       } catch (error) {
//         // let gasPrice1=await web3.eth.getGasPrice()
//         // let gasPrice = parseInt(gasPrice1) + 3000000000
//         // gas=gas*gasPrice
//         // let nd = web3.utils.fromWei(gas.toString(), "ether");
//         // console.log(gas,nd,balance );
//         // if(nd>balance){
//         //    toast.error("Insufficient ETH for Transaction")
//         // }else{
//           throw error;
//         // }
//       }
//     },
//     [contract, account,web3]
//   );
//   return { purchaseEth1: purchaseEth1 };
// };
// export default PurchaseEth1;
